// extracted by mini-css-extract-plugin
export default {"guidelines":"style--guidelines--3c3e2b"};